// extracted by mini-css-extract-plugin
export default {"root":"SplitButton_root__rB4wQ","icon":"SplitButton_icon__BB3Yf"};